var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useCurrentAccount } from '@mysten/dapp-kit';
import { getSuiClient } from '../utils/client';
import { useNetworkString } from './NetworkContext';
const BalanceContext = createContext({
    walletBalancesMap: undefined,
    isLoading: false,
    refetch: () => { },
});
export function getWalletCoins(userAddress, suiClient) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield suiClient.getAllBalances({
                owner: userAddress,
            });
            const resMap = new Map();
            res.forEach((entry) => {
                if (entry.coinType === '0x2::sui::SUI') {
                    resMap.set('0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI', entry.totalBalance);
                }
                resMap.set(entry.coinType, entry.totalBalance);
            });
            return resMap;
        }
        catch (error) {
            console.error('Error fetching tokenBalances!', error);
        }
    });
}
export const BalanceProvider = ({ children }) => {
    const [walletBalancesMap, setWalletBalancesMap] = useState(undefined);
    const network = useNetworkString();
    const [isLoading, setIsLoading] = useState(false);
    const currentAccount = useCurrentAccount();
    const fetchBalances = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!(currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address) || !network)
            return;
        setIsLoading(true);
        try {
            const suiClient = getSuiClient(network);
            const balances = yield getWalletCoins(currentAccount.address, suiClient);
            setWalletBalancesMap(balances);
        }
        catch (error) {
            console.error('Error fetching balances:', error);
        }
        finally {
            setIsLoading(false);
        }
    }), [currentAccount, network]);
    useEffect(() => {
        if (!(currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address))
            return;
        fetchBalances();
        const interval = setInterval(() => {
            fetchBalances();
        }, 5000);
        return () => {
            clearInterval(interval);
        };
    }, [fetchBalances, currentAccount]);
    return (_jsx(BalanceContext.Provider, { value: { walletBalancesMap, isLoading, refetch: fetchBalances }, children: children }));
};
export const useBalances = () => {
    const context = useContext(BalanceContext);
    if (!context) {
        throw new Error('useBalances must be used within a BalanceProvider');
    }
    return context;
};
